import React, { useRef, useState, useEffect } from 'react'
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Image,
    TouchableOpacity,
    ScrollView,
    Platform,
} from 'react-native'
import { FlashList } from '@shopify/flash-list'
import theme from '../../../theme'
import {
    NotificationsModel,
    NotificationStatusConstant,
} from './models/NotificationsModel'
import { TagItem } from '../stores/FormHorizontalTags'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import NetInfo from '@react-native-community/netinfo'
import { apiUrl } from '../../config/config'
import { Loader } from '../customUtils/Components/Loader'
import { onClickRedirect } from '../posts/Go_to'
// import { getFullPath } from '../navigation/hooks/RootNavigation'
import { useNavigation } from '../../hooks/useWebNavigation'
import { getGoTo } from '../appBar/context/GoToContext'
import { openDB } from '../../db/indexDB'
import { FlatList } from 'react-native-gesture-handler'
import styles from './NotificationsStyles'
import { useNotificationStore } from '../../redux/zustand/notificationStore'
import { useFetchPosts } from '../posts/hooks/useFetchPosts'
import { placeholderSearchView } from '../customUtils/Constants'
import { request_notification_status_change } from '../../services/notification.services'
import { Notification } from '../../services/interfaces/notification.interface'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'

const { width, height } = Dimensions.get('window')

export const NOTIFICATION_STATUS: NotificationStatusConstant = {
    NOTIFICATION_DELETE: -1,
    NOTIFICATION_NOT_SEND: 0, //status:0 no enviado
    NOTIFICATION_SEND: 1, //status:1 enviado
    NOTIFICATION_READ: 2, //status:2 leido
    NOTIFICATION_SEE: 3, //status:3 visto
}

export const Notifications = ({ closeSearch }) => {
    const { languageFile } = getLanguage()

    const mainViewRef = useRef(null)
    useFetchPosts()
    const { setWithout_seeing, setWithout_seeing_total } = useNotificationStore()

    const [notifications, setNotifications] = useState<NotificationsModel[]>([])
    const [filteredNotifications, filterNotifications] = useState<
        NotificationsModel[]
    >([])
    const [isLoading, setisLoading] = useState(true)

    const [selectedTag, setSelectedTag] = useState(-1)

    const tags = [languageFile.all, languageFile.unread, languageFile.read]

    const markAllRead = async () => {
        const newNofication = filteredNotifications.map((notification) => {
            return {
                ...notification,
                status: NOTIFICATION_STATUS.NOTIFICATION_READ,
            }
        })

        filterNotifications(newNofication)

        const notifications_ids = JSON.stringify(
            newNofication.map((notification) => notification._id),
        )

        const netInfoState = await NetInfo.fetch()

        if (netInfoState.isConnected) {
            const authToken = await getAuthToken()
            if (!authToken) return

            const params = {
                authToken: authToken,
                notifications_ids: notifications_ids,
                status: NOTIFICATION_STATUS.NOTIFICATION_READ,
            }

            const data = await request_notification_status_change(params)
            // console.log('77 ~ file: markAllRead ~  ~ data:', JSON.stringify(data))
            await fetchData()
        }
    }

    useEffect(() => {
        fetchData().finally(() => setisLoading(false))
    }, [])

    const fetchData = async () => {
        const authToken = await getAuthToken()
        if (!authToken) return
        const netInfoState = await NetInfo.fetch()

        let data

        if (netInfoState.isConnected && authToken) {
            const response = await fetch(`${apiUrl}/get_notifications`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    change: 'true',
                    page: '0',
                    size: '100',
                },
            })
            data = await response.json()

            if (!response.ok) {
                console.error('Fallo al obtener la tienda')

                data = {
                    status: 0,
                }
            }

            if (data?.status === 1) {
                setNotifications(data.single.notifications)
                setSelectedTag(0)
                filterNotifications(data.single.notifications)

                setWithout_seeing(false)
                setWithout_seeing_total(0)
            }
        }
    }

    const onClickTag = (id: string) => {
        setSelectedTag(parseInt(id))
        filterNotifications([])
        if (id == '0') {
            console.log('all')
            filterNotifications(notifications)
        } else {
            filterNotifications(
                notifications.filter((noti) => {
                    if (noti.status != 2 && id == '1') {
                        return true
                    } else {
                        if (noti.status === 2 && id == '2') {
                            return true
                        }
                    }

                    return false
                }),
            )
        }
    }

    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.headerNotifications}>
                {Platform.OS != 'web' && (
                    <Text style={styles.headerTitle}>
                        {languageFile.notifications}
                    </Text>
                )}
                <Text style={styles.headerSubtitle}>
                    {languageFile.here_you_will_find}
                </Text>
            </View>

            {isLoading ? (
                <Loader />
            ) : notifications?.length > 0 ? (
                <>
                    <TouchableOpacity onPress={markAllRead}>
                        <Text style={styles.floatingButtonText}>
                            {languageFile.mark_all_read}
                        </Text>
                    </TouchableOpacity>

                    <View style={styles.containerTags}>
                        <ScrollView
                            horizontal={true}
                            showsHorizontalScrollIndicator={false}
                            style={styles.scrollView}
                        >
                            <View style={styles.tags}>
                                {tags.map((tag, index) => {
                                    const isSelected = selectedTag === index

                                    return (
                                        <TagItem
                                            key={index.toString()}
                                            name={tag}
                                            id={index.toString()}
                                            onClickTag={onClickTag}
                                            isSelected={isSelected}
                                            isSearch={true}
                                        /> // Fix the syntax error by adding a return statement
                                    )
                                })}
                            </View>
                        </ScrollView>
                    </View>
                    <View style={styles.NotificationsBlock}>
                        <FlatList
                            ref={mainViewRef}
                            data={filteredNotifications}
                            horizontal={false}
                            showsVerticalScrollIndicator={false}
                            keyExtractor={(item, index) =>
                                item._id + index.toString()
                            }
                            renderItem={({ item: notification }) => (
                                <NotificationItem
                                    key={notification._id}
                                    notification={notification}
                                    closeSearch={closeSearch}
                                />
                            )}
                            onEndReachedThreshold={0.3}
                            ItemSeparatorComponent={() => (
                                <View style={{ marginVertical: 5 }} />
                            )}
                        />
                    </View>
                </>
            ) : (
                <View style={styles.noScreenContainer}>
                    <View style={styles.noNotificationsBlock}>
                        <View>
                            <Image
                                style={styles.noNotificationIcon}
                                source={require('../notifications/src/assets/no_notifications_new.png')}
                            />
                        </View>
                        <View style={styles.noNotificationTextBlock}>
                            <Text style={styles.noNotificationTitle}>
                                {languageFile.you_have_no_notifications}
                            </Text>
                            <Text style={styles.noNotificationSubtitle}>
                                {languageFile.you_will_soon_start}
                            </Text>
                        </View>
                    </View>
                </View>
            )}
        </View>
    )
}

interface NotificationItemProps {
    notification: NotificationsModel
    closeSearch: () => void
}

const NotificationItem = ({ notification, closeSearch }: NotificationItemProps) => {
    const navigation = useNavigation()
    const { setBenefit, setPostID } = getGoTo()
    const { openBottomSheet } = useBottomSheet()

    const { languageFile } = getLanguage()

    const set_status = (status: number) => {
        switch (status) {
            case 2:
                return languageFile.read
            case 3:
                return languageFile.unread //Visto
            default:
                return languageFile.unread
        }
    }

    const GotoNotif = async (notification: NotificationsModel) => {
        console.log('>>>>>>ir a >', notification)

        // Cerrar el panel de notificaciones primero en web
        if (Platform.OS === 'web') {
            closeSearch()
        }

        if (notification.go_to) {
            const go_to = notification.go_to
            let db = await openDB()
            console.log('JSON ==> ', JSON.stringify(go_to))
            await onClickRedirect(
                go_to,
                navigation,
                setBenefit,
                setPostID,
                db,
                openBottomSheet,
            ).then(() => {
                // En mobile, cerrar después de navegar
                if (Platform.OS !== 'web') {
                    closeSearch()
                }
            })
        }

        const netInfoState = await NetInfo.fetch()

        if (netInfoState.isConnected) {
            const authToken = await getAuthToken()
            if (!authToken) return

            const params = {
                authToken: authToken,
                notification_id: notification._id,
                status: NOTIFICATION_STATUS.NOTIFICATION_READ,
            }

            const data = await request_notification_status_change(params)
            console.log(
                '200🚀 ~ file: Notifications.tsx:200 ~ GotoNotif ~ data:',
                data,
            )
        }
    }

    return (
        <>
            <TouchableOpacity
                style={styles.ItemsBlock}
                onPress={() => GotoNotif(notification)}
            >
                <View
                    style={[
                        styles.notificationData,
                        { opacity: notification.status === 2 ? 0.5 : 1.0 },
                    ]}
                >
                    <View>
                        <Image
                            style={styles.notificationIcon}
                            source={{ uri: placeholderSearchView }}
                        />
                    </View>
                    <View style={styles.textBlockItem}>
                        {notification.title && (
                            <Text
                                style={styles.notificationTitle}
                                ellipsizeMode='tail'
                            >
                                {notification.title}
                            </Text>
                        )}
                        {notification.message && (
                            <Text
                                style={styles.notificationSubtitle}
                                ellipsizeMode='tail'
                            >
                                {notification.message}
                            </Text>
                        )}
                        {notification.date_to_send && (
                            <Text style={styles.notificationDate}>
                                {notification.date_to_send}
                            </Text>
                        )}
                    </View>
                </View>

                <View
                    style={
                        notification.status === 2
                            ? styles.notificationStatusRead
                            : styles.notificationStatusUnread
                    }
                >
                    <Text
                        style={
                            notification.status === 2
                                ? styles.notificationStatusTextRead
                                : styles.notificationStatusTextUnread
                        }
                    >
                        {set_status(notification.status)}
                    </Text>
                </View>
            </TouchableOpacity>
        </>
    )
}
